import clsx from 'clsx';
import { useEffect, useState } from 'react';

const isLocalUrl = (url: string | Blob): url is Blob | string => url instanceof Blob || (typeof url === 'string' && url.startsWith('data'));
const isBlobUrl = (url: string | null): boolean => typeof url === 'string' && url.startsWith('blob');
const generateValue = (data?: string | Blob): string | null => {
  if (!data) return null;
  return isLocalUrl(data) ? URL.createObjectURL(data as Blob) : (data as string);
};

interface LocalImageProps {
  className?: string;
  src?: string | Blob;
  style?: React.CSSProperties;
  alt?: string;
  onClick?: () => void;
}

export const LocalImage = (props: LocalImageProps) => {
  const [src, setSrc] = useState<string | null>(() => generateValue(props.src));

  useEffect(() => {
    if (isBlobUrl(src)) URL.revokeObjectURL(src as string);
    const newSrc = generateValue(props.src);
    setSrc(newSrc);
    return () => {
      if (isBlobUrl(newSrc)) URL.revokeObjectURL(newSrc as string);
    };
  }, [props.src]);

  return <img className={clsx(props.className)} src={src!} alt={props.alt} style={props.style} onClick={props.onClick} />;
};
